var map = {
	"./poster_astramed.jpg": 92,
	"./poster_blash.jpg": 93,
	"./poster_delivery.jpg": 94,
	"./poster_fund.jpg": 95,
	"./poster_jewelry.jpg": 96,
	"./poster_new-year.jpg": 97,
	"./poster_poland.jpg": 98,
	"./poster_web.jpg": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;